'use client';
import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const faqs = [
  {
    q: 'Is it legal for ChallanDesk to settle challans on my behalf?',
    a: 'Yes. ChallanDesk acts as an authorized technology intermediary. Our system uses your challan details to access government portals (echallan.parivahan.gov.in) and complete the payment using your deposited funds. This is a standard assisted-payment service, similar to how travel agents book tickets on your behalf. We do not modify any government records — we only facilitate payment.',
  },
  {
    q: 'How long does settlement take after I pay the platform fee?',
    a: 'Our standard SLA is 24 hours. For B2C users, most challans are settled within 6–12 hours during business hours (9 AM–7 PM). B2B clients on the Fleet plan get priority queue placement.',
  },
  {
    q: 'Which states and cities are covered?',
    a: 'We cover challans PAN India — across all states and union territories. Coverage includes Delhi, Haryana, Maharashtra, Karnataka, Tamil Nadu, Uttar Pradesh, Gujarat, Rajasthan, Madhya Pradesh, Punjab, Himachal Pradesh, Uttarakhand, West Bengal, Telangana, Andhra Pradesh, Kerala, Odisha, Bihar, Jharkhand, Chhattisgarh, Assam, Goa, and more.',
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<string | null>(null);
  return (
    <section className="py-20 bg-background" id="faq">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 max-w-3xl" style={{ maxWidth: '56rem', margin: '0 auto' }}>
        <div className="text-center mb-14">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent mb-3">Common Questions</p>
          <h2 className="text-4xl font-bold text-foreground">Frequently Asked Questions</h2>
        </div>
        <div className="space-y-3">
          {faqs?.map((faq) => (
            <div key={`faq-${faq?.q?.slice(0, 30)}`} className="card-base overflow-hidden">
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-muted transition-colors"
                onClick={() => setOpen(open === faq?.q ? null : faq?.q)}
              >
                <span className="text-sm font-semibold text-foreground pr-4">{faq?.q}</span>
                <ChevronDownIcon
                  className={`w-5 h-5 text-muted-foreground flex-shrink-0 transition-transform duration-200 ${open === faq?.q ? 'rotate-180' : ''}`}
                />
              </button>
              {open === faq?.q && (
                <div className="px-6 pb-5 border-t border-border">
                  <p className="text-sm text-muted-foreground leading-relaxed pt-4">{faq?.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}